import { Row } from '@components/Layout/Row';
import { TabContent, Tabs } from '@packages/tabs';
import React from 'react';

export const DefaultTabsLayout = () => (
    <>
        <Tabs component={Row} />
        <TabContent component={Row} />
    </>
);

DefaultTabsLayout.displayName = 'DefaultTabsLayout';
